export default "__VITE_ASSET__0f1dd315__"